import { useState, useEffect } from "react";
import styled from "styled-components";
import { colors } from "../../../styles/colors";

const Banner = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background-color: ${colors.red};
  color: ${colors.white};
  text-align: center;
  padding: 8px 16px;
  font-size: 14px;
  font-weight: 600;
  z-index: 10000;
`;

function OfflineBanner() {
  const [isOffline, setIsOffline] = useState(!navigator.onLine);

  useEffect(() => {
    const handleOffline = () => setIsOffline(true);
    const handleOnline = () => setIsOffline(false);

    window.addEventListener("offline", handleOffline);
    window.addEventListener("online", handleOnline);

    return () => {
      window.removeEventListener("offline", handleOffline);
      window.removeEventListener("online", handleOnline);
    };
  }, []);

  if (!isOffline) return null;

  return <Banner>אין חיבור לאינטרנט</Banner>;
}

export default OfflineBanner;
